/**
 * Predefined expiration day options for Quick Share (max sharing duration).
 * Used in settings (SettingQuickShareMode) and on the Quick Share page.
 */
export const QUICK_SHARE_EXPIRATION_DAYS = [1, 3, 7, 14, 30, 90, 180, 365] as const;

export type QuickShareExpirationDays = (typeof QUICK_SHARE_EXPIRATION_DAYS)[number];

/** Default max sharing days when not set (matches last option). */
export const QUICK_SHARE_EXPIRATION_DEFAULT_DAYS = 365;

/**
 * Returns the given value if it is one of the allowed expiration days, otherwise the default.
 * Use when reading maxSharingDays from API that might send values outside the predefined list.
 */
export function normalizeQuickShareExpirationDays(value: number | undefined | null): number {
  if (value != null && (QUICK_SHARE_EXPIRATION_DAYS as readonly number[]).includes(value)) {
    return value;
  }
  return QUICK_SHARE_EXPIRATION_DEFAULT_DAYS;
}

/**
 * Returns expiration options filtered by max allowed days (e.g. from user settings).
 * Use on the Quick Share page to only show options <= user's qsDays.
 */
export function getQuickShareExpirationOptionsFiltered(maxDays: number): number[] {
  return QUICK_SHARE_EXPIRATION_DAYS.filter((d) => d <= maxDays);
}
